import AvatarIcon from "@icons/avatar-icon";
import BriefcaseIcon from "@icons/briefcase-icon";
import ChatsIcon from "@icons/chats-icon";
import DocumentWithCheckIcon from "@icons/document_with_check-icon";
import EyeIcon from "@icons/eye-icon";
import HandHoldingHeartIcon from "./hand_holding_heart-icon";
import HappyChatIcon from "@icons/happy_chat-icon";
import InfoIcon from "@icons/info-icon";
import LivingChairIcon from "@icons/living_chair-icon";
import MedalWithDollarSignIcon from "@icons/medal-with-dollar-sign-icon";
import MedicineIcon from "@icons/medicine-icon";
import NewsIcon from "@icons/news-icon";
import RabbitIcon from "@icons/rabbit-icon";
import ShakingHandsIcon from "@icons/shaking_hands-icon";
import VerifiedIcon from "@icons/verified-icon";
import VerifiedSquigglyIcon from "@icons/verified-squiggly-icon";
import type { JSX } from "preact";

const iconMap: Record<string, JSX.Element> = {
  avatar: <AvatarIcon />,
  briefcase: <BriefcaseIcon />,
  chats: <ChatsIcon />,
  document_with_check: <DocumentWithCheckIcon />,
  eye: <EyeIcon />,
  hand_holding_heart: <HandHoldingHeartIcon />,
  happy_chat: <HappyChatIcon />,
  info: <InfoIcon />,
  living_chair: <LivingChairIcon />,
  'medal-with-dollar-sign': <MedalWithDollarSignIcon />,
  medicine: <MedicineIcon />,
  prescription: <MedicineIcon />,
  news: <NewsIcon />,
  rabbit: <RabbitIcon />,
  shaking_hands: <ShakingHandsIcon />,
  verified: <VerifiedIcon />,
  'verified-squiggly': <VerifiedSquigglyIcon />,
};

export const Icon = ({ icon }: { icon: string }) => {
  return iconMap[icon] ?? null;
};

export default Icon;
